import React from 'react';
import classnames from 'classnames';
import TimeAgo from 'timeago-react';

import BackNavigate from 'components/BackNavigate';

import * as styles from './hero.module.scss';

const ResourceCenterPost = ({ data, customFields }) => {
  const { title, excerpt, /*categories,*/ tags, date, seo } = data;
  const TIME_READ = seo.readingTime;

  const POSTED_BY = customFields.resourceCenterPostPostedBy;

  return (
    <section className={classnames(styles.section)}>
      <div className={classnames(styles.head)}>
        <BackNavigate />

        <h1 className={classnames(styles.title)}>{title}</h1>

        <p
          className={classnames(styles.subtitle, 'scr-lead')}
          dangerouslySetInnerHTML={{ __html: excerpt }}
        ></p>
      </div>

      <div className={classnames(styles.info)}>
        <div className={classnames(styles.info_tags)}>
          <ul className={classnames(styles.tagsList)}>
            {tags.nodes.map((tag) => {
              return (
                <li key={tag.slug} className="scr-article-tag">
                  <span
                    className={classnames(
                      `tag-${tag.slug}`,
                      'scr-txt-up',
                      'tag-common'
                    )}
                  >
                    {tag.name}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>

        <div className={classnames(styles.info_readTime, 'scr-txt-up')}>
          {TIME_READ} min read
        </div>

        <div>
          Posted <TimeAgo datetime={date} locale="en-US" /> by{' '}
          <span className="scr-blue">{POSTED_BY}</span>
        </div>
      </div>
    </section>
  );
};

export default ResourceCenterPost;
